<template>
    <div class="form-field-group" v-bind:class="{'error-active': error}">
        <div v-if="error" class="error-container">
            <div class="error-block">
                <p>{{error}}</p>
            </div>
        </div>
        <slot></slot>
    </div>
</template>

<script type = "text/javascript">
    export default {
        props: {
            error: String,
        }
    }
</script>
